import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { Empresa } from "../Hooks/UsuarioHook";
import { useUsuarioPrefeitura } from "../Hooks/UsuarioPrefeituraHook";
import { API } from "../Services/Api";

interface ISeletorContextData {
  tela: string;
  setTela: React.Dispatch<React.SetStateAction<string>>;

  resumo: boolean;
  setResumo: React.Dispatch<React.SetStateAction<boolean>>;

  alterados: boolean;
  setAlterados: React.Dispatch<React.SetStateAction<boolean>>;

  pagos: boolean;
  setPagos: React.Dispatch<React.SetStateAction<boolean>>;

  pendentes: boolean;
  setPendentes: React.Dispatch<React.SetStateAction<boolean>>;
}

interface ISeletorProviderProps {
  children: ReactNode;
}

const SeletorContext = createContext({} as ISeletorContextData);

function SeletorProvider({ children }: ISeletorProviderProps) {
  const { usuarioPrefeitura } = useUsuarioPrefeitura();

  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const [loading, setLoading] = useState(false);

  const [tela, setTela] = useState("guias");
  const [resumo, setResumo] = useState(false);

  const [alterados, setAlterados] = useState(false);

  const [pagos, setPagos] = useState(false);
  const [pendentes, setPendentes] = useState(false);

  return (
    <SeletorContext.Provider
      value={{
        tela,
        setTela,
        resumo,
        setResumo,
        alterados,
        setAlterados,
        pagos,
        pendentes,
        setPagos,
        setPendentes,
      }}
    >
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </SeletorContext.Provider>
  );
}

function useSeletor() {
  const context = useContext(SeletorContext);

  return context;
}

export { SeletorProvider, useSeletor };
